const newCatalogs = [
  {
    nombre: "Usuarios Notificación",
    tabla: "cat_usuarios_notificacion",
    fieldToUpdate: "idcat_usuario_notificacion",
    fields: [
      {
        key: "idcat_estatus",
        type: "select",
        service: "obtenerCatalogoEstatus",
        value: "idcat_estatus",
        label: "estatus"
      },
      {
        key: "idcat_puesto",
        type: "select",
        service: "obtenerCatalogo",
        serviceParams: { tableName: "cat_puestos" },
        value: "idcat_puesto",
        label: "descripcion"
      },
      {
        key: "idcat_departamento",
        type: "select",
        service: "obtenerCatalogo",
        serviceParams: { tableName: "cat_departamentos" },
        value: "idcat_departamento",
        label: "descripcion"
      },
      { key: "usuario", type: "text" },
      { key: "id_externo", type: "text" },
      { key: "correo", type: "text" },
      {
        key: "tipo_notification",
        type: "select",
        options: ["CONTABILIDAD", "COMPRAS"]
      }
    ]
  },
  {
    nombre: "Usuarios Amex",
    tabla: "cat_amex_directores_asistentes",
    fieldToUpdate: "idcat_amex",
    fields: [
      {
        key: "idcat_estatus",
        type: "select",
        service: "obtenerCatalogoEstatus",
        value: "idcat_estatus",
        label: "estatus"
      },
      { key: "nombre_director", type: "text" },
      {
        key: "idusuario_asistente",
        type: "select",
        service: "usuarios",
        serviceMethod: "get",
        responseField: "usuarios",
        value: "id",
        label: "nombre"
      },
      { key: "puesto_director", type: "text" },
      { key: "cuenta", type: "text" },
      { key: "subcuenta", type: "text" },
      { key: "id_externo", type: "text" }
    ]
  },
  {
    nombre: "Usuarios RH",
    tabla: "cat_recursos_humanos",
    fieldToUpdate: "idcat_recurso_humano",
    fields: [
      {
        key: "idcat_estatus",
        type: "select",
        service: "obtenerCatalogoEstatus",
        value: "idcat_estatus",
        label: "estatus"
      },
      {
        key: "idusuario",
        catalog: "idusuario_asistente",
        type: "select",
        service: "usuarios",
        serviceMethod: "get",
        responseField: "usuarios",
        value: "id",
        label: "nombre"
      },
      {
        key: "idcat_direccion",
        type: "select",
        service: "obtenerCatalogo",
        serviceParams: { tableName: "cat_direcciones" },
        value: "idcat_direccion",
        label: "descripcion"
      },
      {
        key: "idcat_empresa",
        type: "select",
        service: "obtenerCatalogo",
        serviceParams: { tableName: "cat_empresas" },
        value: "idcat_empresa",
        label: "descripcion"
      },
      {
        key: "idcat_puesto",
        type: "select",
        service: "obtenerCatalogo",
        serviceParams: { tableName: "cat_puestos" },
        value: "idcat_puesto",
        label: "descripcion"
      },
      { key: "id_externo", type: "text" }
    ]
  },
  {
    nombre: "Puestos de representación",
    tabla: "cat_puestos_gastos_representacion",
    fieldToUpdate: "idcat_puesto_gasto",
    fields: [
      {
        key: "idcat_estatus",
        type: "select",
        service: "obtenerCatalogoEstatus",
        value: "idcat_estatus",
        label: "estatus"
      },
      {
        key: "idusuario",
        catalog: "idusuario_asistente",
        type: "select",
        service: "usuarios",
        serviceMethod: "get",
        responseField: "usuarios",
        value: "id",
        label: "nombre"
      },
      { key: "usuario", type: "text" },
      { key: "id_externo", type: "text" },
      { key: "monto_maximo_solicitud_representacion", type: "number" },
      { key: "monto_maximo_persona", type: "number" }
    ]
  }
];

export default newCatalogs;
